module.exports = __webpack_public_path__ + "img/viewmarks.42524dad.svg";